<ng-container *ngFor="let metric of metricRow.metrics">
  <ng-container *ngIf="metric">
    <div class="col-3 mb-2">
      <ds-metric-loader [metric]="metric"></ds-metric-loader>
    </div>
  </ng-container>
</ng-container>
